import React, { useEffect, useCallback, useState} from 'react';
import RackComponent from "components/effects/rack/RackComponent.js";
import {connect} from 'react-redux';

const Rules = ({effect, sequencerEngine, track}) => { 
    let [chosenRule, setChosenRule] = useState(1);
    let rules = effect.rules[chosenRule - 1];
    return (
        <div className="rules-screen">
          <RackComponent
                    effect={rules}
                    track={track}
                    sequencerEngine={sequencerEngine}/>
          <div className="rules-chooser">
            {effect.rules.map(
                (x,i) => <div
                           onClick={() => setChosenRule(i+1)}
                           className={i+1===chosenRule ? "selected rule" : "rule"}>{i+1}</div>)}
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Rules);
